/**
 * Single Event — Share widget in the sidebar.
 */

import { initShareWidget } from './share-widget';

document.querySelectorAll( '.single-event' ).forEach( initShareWidget );
